import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=9555c7ba&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&lang=ts"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=9555c7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9555c7ba",
  null
  
)

export default component.exports